/** Session-only pending 2FA JWT from password step. */
export const TWO_FACTOR_TEMP_TOKEN_KEY = "gt_twoFactorTempToken";

/** Where to send the user after successful OTP (e.g. `/create-profile` or `/admin/companies`). */
export const TWO_FACTOR_RETURN_PATH_KEY = "gt_twoFactorReturnPath";

/** Long-lived device token after “trust this device” (optional). */
export const TWO_FACTOR_DEVICE_TOKEN_KEY = "gt_twoFactorDeviceToken";
